import { Bad } from '@core/model/framework/Result/BadResult';
import { Ok } from '@core/model/framework/Result/OkResult';
import { Usecase } from '@core/model/framework/usecase';
import type { BankService } from '@core/model/service/bankService';
import { SERVICE_ID } from '@di/serviceId';
import { inject, injectable } from 'inversify';

export type SaveWebauthBankConnectionError = 'SAVE_BANK_CONNECTION_FAILED';

export type SaveWebauthBankConnectionInput = {
  webauthPopupUserToken: string;
  webauthPopupConnectionId: string;
};

export type SaveWebauthBankConnectionOutput = Promise<Ok | Bad<SaveWebauthBankConnectionError>>;

@injectable()
export class SaveWebauthBankConnection
  implements Usecase<SaveWebauthBankConnectionInput, SaveWebauthBankConnectionOutput>
{
  constructor(
    @inject(SERVICE_ID.bankService)
    private readonly bankService: BankService
  ) {}

  async execute(cmd: SaveWebauthBankConnectionInput): SaveWebauthBankConnectionOutput {
    return this.bankService.saveWebauthBankConnection(cmd);
  }
}
